import React from "react";
import { Link as RouterLink, LinkProps as RouterLinkProps } from "react-router-dom";
import { Link as MUILink, Theme, createStyles, makeStyles } from "@material-ui/core";
import { LinkProps } from "@material-ui/core/Link";
import cn from "classnames";
import * as H from "history";

export const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    common: {
      paddingBottom: "4px",
      cursor: "pointer",
      "&:hover": {
        textDecoration: "none",
        paddingBottom: "2px",
        borderBottom: `2px solid ${theme.palette.common.white}`,
      },
    },
    active: {
      textDecoration: "none",
      paddingBottom: "2px",
      borderBottom: `2px solid ${theme.palette.common.white}`,
    },
    disabled: {},
  }),
);

const LinkComponent = React.forwardRef<HTMLAnchorElement, RouterLinkProps>((props, ref) => (
  <RouterLink innerRef={ref} {...props} />
));

export function Link({
  active,
  ...otherProps
}: LinkProps & RouterLinkProps & { disabled?: boolean; active?: boolean }) {
  const to = otherProps.to || (otherProps.href as H.LocationDescriptor<H.LocationState>);
  const isOuterLink = `${to}`.includes("http");
  const target = isOuterLink ? "_blank" : "_self";
  const classes = useStyles(otherProps);
  const { disabled } = otherProps;
  const classname = cn(classes.common, otherProps.className, {
    [classes.disabled]: disabled,
    [classes.active]: !!active,
  });

  const onClick = (event: React.MouseEvent) => {
    if (disabled) {
      event.preventDefault();
    }

    if (isOuterLink) {
      event.preventDefault();
      window.open(`${to}`, target);
    }

    if (otherProps.onClick) {
      otherProps.onClick(event as React.MouseEvent<HTMLAnchorElement, MouseEvent>);
    }
  };

  return (
    <MUILink
      component={LinkComponent}
      target={target}
      {...(otherProps as LinkProps)}
      to={to}
      className={classname}
      onClick={onClick}
    />
  );
}

export default Link;
